const RANKING_ITEMS = [
  {
    id: 1,
    rank: 1,
    title: '都市夜未央',
    platform: '香蕉视频',
    type: '都市情感',
    heat: '9.8万',
    trend: 'up',
    change: '+3',
  },
  {
    id: 2,
    rank: 2,
    title: '暗影追踪者',
    platform: '糖豆视频',
    type: '悬疑烧脑',
    heat: '9.5万',
    trend: 'up',
    change: '+1',
  },
  {
    id: 3,
    rank: 3,
    title: '江山万里图',
    platform: '蓝莓视频',
    type: '古装历史',
    heat: '9.2万',
    trend: 'down',
    change: '-2',
  },
  {
    id: 4,
    rank: 4,
    title: '迷雾深渊',
    platform: '糖豆视频',
    type: '悬疑惊悚',
    heat: '8.7万',
    trend: 'up',
    change: '+5',
  },
  {
    id: 5,
    rank: 5,
    title: '幸福小区',
    platform: '小蓝视频',
    type: '家庭喜剧',
    heat: '8.3万',
    trend: 'down',
    change: '-1',
  },
  {
    id: 6,
    rank: 6,
    title: '无声的证词',
    platform: '香蕉视频',
    type: '悬疑推理',
    heat: '7.9万',
    trend: 'up',
    change: '+8',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-3">
            实时排行
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-2">热度排行</h2>
          <p className="text-sm text-foreground-500 max-w-md mx-auto">
            玫瑰视频各平台影视热度实时排名
          </p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
          {RANKING_ITEMS.map((item) => (
            <div
              key={item.id}
              className="flex items-center gap-3 md:gap-5 px-4 md:px-6 py-4 border-b border-background-200/70 last:border-b-0 hover:bg-background-100/50 transition-colors duration-200 cursor-pointer"
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center text-sm font-bold ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap">
                  <h3 className="text-sm md:text-base font-medium text-foreground-950 truncate">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-700 whitespace-nowrap">
                    {item.platform}
                  </span>
                </div>
                <div className="text-xs text-foreground-400 mt-0.5">{item.type}</div>
              </div>

              <div className="flex-shrink-0 text-right">
                <div className="text-sm font-bold text-foreground-950">{item.heat}</div>
                <div className={`text-xs flex items-center justify-end gap-0.5 ${
                  item.trend === 'up' ? 'text-primary-600' : 'text-secondary-600'
                }`}>
                  {item.trend === 'up' ? (
                    <i className="ri-arrow-up-line text-xs"></i>
                  ) : (
                    <i className="ri-arrow-down-line text-xs"></i>
                  )}
                  {item.change}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}